import { HeroShowcase } from "@/components/HeroShowcase";
import { IntroStatement } from "@/components/IntroStatement";
import { Marquee } from "@/components/Marquee";
import { ProductsShowcase } from "@/components/ProductsShowcase";
import { FireplaceImage } from "@/components/FireplaceImage";
import { ProfilesSection } from "@/components/ProfilesSection";
import { FixedProjectImage } from "@/components/FixedProjectImage";
import { ProcessSection } from "@/components/ProcessSection";
import { FullVideo } from "@/components/FullVideo";
import { OurStory } from "@/components/OurStory";
import { ProductsGrid } from "@/components/ProductsGrid";
import { EnquiryForm } from "@/components/EnquiryForm";
import { PROJECT_IMAGE_2 } from "@/constants/assets";

export default function Home() {
  return (
    <>
      <HeroShowcase />
      <IntroStatement />
      <Marquee />
      <ProductsShowcase />
      <FireplaceImage />
      <ProfilesSection />
      <FixedProjectImage />
      <ProcessSection />
      <FullVideo />
      <OurStory />
      <FixedProjectImage
        image={PROJECT_IMAGE_2}
        eyebrow="— Featured Build"
        id="featured-build"
        testid="fixed-project-image-2"
      />
      <ProductsGrid />
      <EnquiryForm />
    </>
  );
}
